// extracted by mini-css-extract-plugin
module.exports = {"checkboxContainer":"policy_checkbox_checkboxContainer__17UHl","policyText":"policy_checkbox_policyText__x09xw","link":"policy_checkbox_link__1ixeX"};